import { IsNotEmpty, IsIn, IsOptional, IsNumber } from "class-validator";
import { Constants } from "@eagerdog/constants";

export class FastdashScoreDto {
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsOptional()
  @IsNumber()
  time?: number;
}
